export type KpiAxisCategory =
  | "PRICE"
  | "VALUE"
  | "UNITS"
  | "PERCENTAGE"
  | "WEEKS";

/** Maps the grid's metricCategoryMapping values to axis categories. */
export const CATEGORY_TO_AXIS: Record<string, KpiAxisCategory | undefined> = {
  Value: "VALUE",
  Price: "PRICE",
  Units: "UNITS",
  Weeks: "WEEKS"
};

/**
 * KPI color palettes — 4 shades per category, cycled when multiple traces
 * share the same category.
 */
export const GRAPH_COLOURS: Record<KpiAxisCategory, string[]> = {
  PERCENTAGE: [
    "hsla(130, 62%, 38%, 1)",
    "hsla(125, 34%, 52%, 1)",
    "hsla(114, 45%, 74%, 1)",
    "hsla(108, 49%, 88%, 1)"
  ],
  UNITS: [
    "hsla(214, 45%, 49%, 1)",
    "hsla(203, 50%, 64%, 1)",
    "hsla(195, 58%, 79%, 1)",
    "hsla(193, 63%, 93%, 1)"
  ],
  VALUE: [
    "hsla(33, 87%, 29%, 1)",
    "hsla(35, 62%, 46%, 1)",
    "hsla(42, 60%, 68%, 1)",
    "hsla(44, 74%, 86%, 1)"
  ],
  PRICE: [
    "hsla(3, 69%, 50%, 1)",
    "hsla(14, 89%, 61%, 1)",
    "hsla(30, 98%, 69%, 1)",
    "hsla(44, 98%, 78%, 1)"
  ],
  WEEKS: [
    "hsla(270, 50%, 40%, 1)",
    "hsla(268, 45%, 55%, 1)",
    "hsla(266, 50%, 72%, 1)",
    "hsla(264, 60%, 88%, 1)"
  ]
};

export const AXIS_COLOURS: Record<KpiAxisCategory, string> = {
  PERCENTAGE: GRAPH_COLOURS.PERCENTAGE[0],
  UNITS: GRAPH_COLOURS.UNITS[0],
  VALUE: GRAPH_COLOURS.VALUE[0],
  PRICE: GRAPH_COLOURS.PRICE[0],
  WEEKS: GRAPH_COLOURS.WEEKS[0]
};

/** y-key suffix used per axis so AG Charts can bind series to the correct axis. */
export const AXIS_YKEY: Record<KpiAxisCategory, string> = {
  PRICE: "value_price",
  VALUE: "value_value",
  UNITS: "value_units",
  PERCENTAGE: "value_percentage",
  WEEKS: "value_weeks"
};

/**
 * Block names that correspond to inventory metrics.
 * Inventory KPIs render as bars (not lines). Display only — whether a series
 * accumulates is decided by its `metricTemporalAgg` rule, not by this list.
 */
export const INVENTORY_BLOCKS = new Set([
  "Intake",
  "BOP",
  "EOP",
  "Target Stock",
  "FPOS",
  "OTB",
  "POTB"
]);

/** Metrics that cannot be shown in stacked view. */
export const UNSTACKABLE_METRICS = new Set(["STORE_SQM", "STORE_COUNT"]);

/**
 * Combined color palette for stacked chart series.
 * Cycles through all 5 category palettes (20 colors total).
 */
export const STACKED_COLOURS = [
  ...GRAPH_COLOURS.UNITS,
  ...GRAPH_COLOURS.VALUE,
  ...GRAPH_COLOURS.PRICE,
  ...GRAPH_COLOURS.PERCENTAGE,
  ...GRAPH_COLOURS.WEEKS
];
